import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: 'account', loadChildren: () => import('./features/account/account.routes').then(m => m.accountRoutes) },
  { path: 'blog', loadChildren: () => import('./features/blog/blog.routes').then(m => m.blogRoutes) },
  { path: 'donate', loadChildren: () => import('./features/donate/donate.routes').then(m => m.donateRoutes) },
  { path: 'donation', loadChildren: () => import('./features/donation/donation.routes').then(m => m.donationRoutes) },
  { path: 'error', loadChildren: () => import('./features/error/error.routes').then(m => m.errorRoutes) },
  { path: 'legal', loadChildren: () => import('./features/legal/legal.routes').then(m => m.legalRoutes) },
  { path: '', loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent) },
  
  { path: '**', redirectTo: 'error/404' }
];
